import React from 'react'
import Breadcrumbs from '../breadcrumbs'
import ClientCardContainer from '../clientcardcontainer'

import styles from './index.module.scss'

export const Dashboard: React.FC = () => {
  return (
    <>
      <div className={styles.dashboard}>
        <Breadcrumbs></Breadcrumbs>
        <ClientCardContainer></ClientCardContainer>
      </div>
    </>
  )
}
